import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../services/Validator";
import {renderBorderColor} from "../../../controllers/SystemOptionProposalController";

export default function LevelAExampleAnswerText({answer, isBrevetDisplay}) {
    // Used in LevelAExampleQuestion to display answer
    // text in LateX

    // BUILD
    if (isNullOrUndefined(answer))
        return null
    return (
        <div className={`w-full flex justify-center`}>
            <div className={`${isBrevetDisplay ? "bg-greenStar/10" : "bg-primary"}  rounded-[8px] py-[6px] px-[12px] ${renderBorderColor(true)}`}>
                <MathJaxContext>
                    <MathJax inline dynamic>
                        <span className={`font-bold ${isBrevetDisplay ? "text-greenStar" : "text-white"} text-[20px]`}>
                            {answer}
                        </span>
                    </MathJax>
                </MathJaxContext>
            </div>
        </div>
    );
}